import { ButtonGroupRoot } from "./ButtonGroupRoot";
import { ButtonItem } from "./ButtonItem";

export const ButtonGroup = {
  Root: ButtonGroupRoot,
  Item: ButtonItem,
};
